import { styled, Skeleton } from '@ori-ui/mui';

import { LinkColumn } from '../LinkColumn/LinkColumn';

export const AppIconSkeleton = styled(Skeleton)(({ theme }) => ({
  transform: 'none',
  display: 'inline-block',
  margin: theme.spacing(1, 1),
  width: 35,
  height: 35,
  overflow: 'hidden',
}));

export const Root = styled(LinkColumn)(({ theme }) => ({
  textAlign: 'center',
  display: 'flex',
  flexFlow: 'column',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    margin: 'auto',
  },
}));
